module.exports = __webpack_public_path__ + "img/amb-logo-full.1dcb988f.png";